import '.c6{display:inline-flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.ic{padding:0.6rem;}.ssr-plugin'
import '.id{border-radius:1.875rem;}.ssr-plugin'
import '.ie{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.if{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.dr{border-radius:2rem;}.ssr-plugin'
import '.ig{overflow-x:hidden;}.ssr-plugin'
import '.bz{overflow-y:auto;}.ssr-plugin'
import '.ih{background:var(--page-bg);}.ssr-plugin'
import '.ac{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="c6 e t v ic id ie if"
      style={{
        ...style,
      }}
    >
      <styled.div className="dr ig bz ih ac"
        style={{
          width,
          height,}}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
